import { useState } from "react";
import Modal from "react-modal";
import { connect } from "react-redux";
import { CLOSE_RATING_MODAL, SUBMIT_RATING } from "redux/chat";
import trackEvent from "utils/trackEvent";
import "./style.scss";

const MAX_COMMENT_LENGTH = 500;

// Shape cloned from the (no longer present in this checkout) AddCommentModal
// pattern: char-counter textarea + footer buttons. Always shown after a
// star click, comment stays optional (Skip submits with an empty comment).
const RatingCommentModal = ({ ratingTarget, close, submitRating }) => {
  const [comment, setComment] = useState("");
  const isOpen = !!ratingTarget;

  const handleClose = () => {
    setComment("");
    close();
  };

  const submit = withComment => {
    trackEvent("CHAT_SUBMIT_RATING", {
      rating: ratingTarget.rating,
      hasComment: withComment && !!comment,
    });
    submitRating({
      entryId: ratingTarget.entryId,
      rating: ratingTarget.rating,
      comment: withComment ? comment : "",
    });
    setComment("");
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      className="rating-comment-modal"
      overlayClassName="rating-comment-modal-overlay">
      <div className="rating-comment-modal-header">
        <h3>Would you like to add a comment to your rating?</h3>
        <button
          type="button"
          className="rating-comment-modal-close"
          onClick={handleClose}>
          ×
        </button>
      </div>
      <textarea
        className="rating-comment-modal-textarea"
        placeholder="Write your feedback here (optional)..."
        value={comment}
        maxLength={MAX_COMMENT_LENGTH}
        onChange={e => setComment(e.target.value)}
        rows={4}
      />
      <div className="rating-comment-modal-counter">
        {comment.length}/{MAX_COMMENT_LENGTH}
      </div>
      <div className="rating-comment-modal-actions">
        <button
          type="button"
          className="rating-comment-modal-skip"
          onClick={() => submit(false)}>
          Skip
        </button>
        <button
          type="button"
          className="rating-comment-modal-submit"
          onClick={() => submit(true)}>
          Submit
        </button>
      </div>
    </Modal>
  );
};

export default connect(
  ({ chat: { ratingTarget } }) => ({ ratingTarget }),
  dispatch => ({
    close: () => dispatch(CLOSE_RATING_MODAL()),
    submitRating: payload => dispatch(SUBMIT_RATING(payload)),
  })
)(RatingCommentModal);
